import React from 'react';
import Button from '../Button';
import * as s from './styles';

const Banner = ({ title, subtitle, buttonText, imageUrl, logoSrc }) => {
  const handleClick = () => {
    window.location.href = 'https://bluemed.cc/';
  };

  return (
    <s.BannerContainer imageUrl={imageUrl}>
      <s.TextOverlay>
        <s.Logo src={logoSrc} alt='Logo' />
        <s.Content>
          <s.TextImage src='/assets/text-image.svg' alt='Texto' />

          <s.Subtitle>{subtitle}</s.Subtitle>
        </s.Content>
      </s.TextOverlay>
      <s.BtnFixed>
        <Button onClick={handleClick}>{buttonText}</Button>
      </s.BtnFixed>
    </s.BannerContainer>
  );
};

export default Banner;
